export const errors = {
  "403": "You don't have access to this page.",
  "404": "This page doesn't seem to exist.\nIt might have been deleted or moved.",
  "500": "The application has encountered an unknown error. Try again after a few moments.",
  "502": "Something went wrong. Try again after a few moments.",
  "403_action": "You don't have permission to perform this action.",
  "404_action": "This object does not exist.\nIt might have been deleted or moved.",
  authError: "An error occurred during the login flow. Please try again.",
  authLinkError:
    "Something wrong happened. Probably you used the wrong URL to access this page. Back to home and try again.",
  fetch_error: "Network is unreachable. Try again after a few moments.",
  incorrect_url: "This url is incorrect.",
  no_tenant: "You should contact an admin.",
  superadmin_no_tenant: "You should pick the tenant first, or set the default one.",
  Take_me_home: "Take me home",
  Try_again: "Try again",
  unknown: "The application has encountered an unknown error. Try again after a few moments.",
  if_error_persists: "If the error persists, please contact the <a>support team</a>",
  mapping_download_error: "An error occurred during the mapping download",
} as const;
